import React, { Component } from 'react';
import CalendarRow from '../components/internal/CalendarRow';
import AcceptContractPopup from '../components/internal/Popups/AcceptContractPopup';

import MediaQuery from 'react-responsive';
import Parse from 'parse';
import { inject } from 'mobx-react'

@inject('golfCourseStore', 'datesStore', 'partnerInformationStore')
export default class Playground extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: undefined
    }

  }

  componentWillMount() {}

  render() {

    const run = async () => {
      const result = await Parse.Cloud.run("deleteCompany", { id: "x8IDWMW866" })
      console.log(result);
    }

    return (
      <div style={{paddingTop:80}}>
       { this.state.data }
       <button onClick={run}>PRESS ME TO TEST</button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// /src/pages/Playground.js